import script from "./FormGeolocationEdition.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormGeolocationEdition.vue?vue&type=script&setup=true&lang=ts"

import "./FormGeolocationEdition.vue?vue&type=style&index=0&id=518ec843&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-518ec843"]])

export default __exports__